/*
 * @Author: czj
 * @Date: 2025-04-17 15:32:20
 * @Description: 
 * @FilePath: \kp-rag-system\src\utils\auth.js
 */
import Cookies from 'js-cookie';
const TokenKey = 'Admin-Token';
const ticket = 'ticket';

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

//ticket
export function getTicket() {
  return Cookies.get(ticket);
}
export function setTicket(t) {
  return Cookies.set(ticket, t)
}
export function removeTicket() {
  return Cookies.remove(ticket)
}